<template>
  <Toast />
  <div class="card-header">
    <h4>Documentos Emitidos</h4>
    <div class="line_title"></div>
  </div>
  <div class="card-body">
    <div>
      <!-- DT NotasDC -->
      <DataTable v-model:expandedRows="expandedRows" ref="dt" :value="facturas" :paginator="true" :rows="10" style="zoom: 0.80;"
        :loading="loading" removableSort :globalFilterFields="['cliente.rut_dv','cliente.razon_social','tipoDocumento.codigo', 'folio', 'fecha', 'neto', 'iva', 'total', 'debitoCreditoNotas']" sortMode="multiple" dataKey="id" filterDisplay="row" 
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" v-model:filters="filters"
        responsiveLayout="scroll" breakpoint="990px" class="ndc-table">        

        <template #header>
          <!-- DT Toolbar-->
          <Toolbar class="">
            <template #start>
              <label for="rango"><h4>Rango de Fechas:&nbsp;</h4></label>
              <Calendar id="rango" v-model="rango" dateFormat="dd/mm/y" selectionMode="range"
                autocomplete="cc-csc" :showIcon="true" :manualInput="false"
                :hideOnDateTimeSelect="true" />&nbsp;&nbsp;&nbsp;
              <Button icon="pi pi-search" class="p-button-primary" @click="getCRUD($event)" outlined/>                            
            </template>   
            <template #end>
              <div class="table-header flex flex-column md:flex-row md:justiify-content-between">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                </span>
              </div>              
            </template>                     
          </Toolbar>          
        </template>

        <Column expander/>

        <Column field="cliente.rut_dv" header="RUT" style="width:7%;" sortable>
          <template #body="slotProps">
            <span>
              {{ slotProps.data.cliente.rut_dv }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="" />
          </template>           
        </Column>

        <Column field="cliente.razon_social" header="Cliente" style="width:22%;" sortable>
          <template #body="slotProps">
            <span>
              {{ slotProps.data.cliente.razon_social }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="" />
          </template>           
        </Column>

        <Column field="tipoDocumento.codigo" header="Tipo" style="width:2%;" sortable>
          <template #body="slotProps">
            <Tag :value="slotProps.data.tipoDocumento.codigo" :severity="slotProps.data.tipoDocumento.codigo === 'FE' ? 'info' : 'warning'" />
          </template>          
        </Column>         

        <Column field="folio" header="Folio"  style="width:5%;white-space: nowrap;text-align: right;" sortable>
          <template #body="slotProps">
            <span>
              {{ slotProps.data.folio }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="" />
          </template>           
        </Column>

        <Column field="fecha" header="Fecha" style="width:7%;white-space: nowrap;text-align: center;" sortable>
          <template #body="slotProps">
            <span>
              {{ slotProps.data.fecha }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="" />
          </template>           
        </Column>

        <Column field="neto" style="width:10%;text-align: right;" sortable>
          <template #header>
            <div style="text-align: right!important; padding-left: 35%!important;color:white;" >Mnt.Neto</div>
          </template>
          <template #body="slotProps">
            <span>
              {{ formatCurrency(slotProps.data.neto) }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="" />
          </template>           
        </Column>

        <Column field="iva" style="width:7%;text-align: right;" sortable>
          <template #header>
            <div style="text-align: right!important; padding-left: 35%!important;color:white;" >Mnt.IVA</div>
          </template>        
          <template #body="slotProps">
            <span>
              {{ formatCurrency(slotProps.data.iva) }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="" />
          </template>           
        </Column>        

        <Column field="total" style="width:8%;text-align: right;" sortable>
          <template #header>
            <div style="text-align: right!important; padding-left: 35%!important;color:white;" >Mnt.Total</div>
          </template>          
          <template #body="slotProps">
            <strong>
              {{ formatCurrency(slotProps.data.total) }}
            </strong>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="" />
          </template>           
        </Column>

        <Column field="debitoCreditoNotas" style="width:8%;text-align: right;" sortable>
          <template #header>
            <div style="text-align: right!important; padding-left: 50%!important;">N.Crédito</div>
          </template>          
          <template #body="slotProps">
            <div style="display: flex; align-items: flex-start; justify-content: flex-end;">
              <sup style="color: red; font-size: 0.8em; margin-right: 20px;margin-top: 8px;">{{ getNotaData(slotProps.data.debitoCreditoNotas, '5 19 23') }}</sup>
              <strong style="color: red; text-align: right;">
                {{ formatCurrency(getSumNota(slotProps.data.debitoCreditoNotas, '5 19 23')) }}
              </strong>
            </div>
          </template> 
        </Column>

        <Column field="creditoDebitoNotas" style="width:8%;text-align: right;" sortable>
          <template #header>
            <div style="text-align: right!important; padding-left: 50%!important;" >N.Débito</div>
          </template>               
          <template #body="slotProps">
            <div style="display: flex; align-items: flex-start; justify-content: flex-end;">
              <sup style="color: green; font-size: 0.8em; margin-right: 20px;margin-top: 8px;">{{ getNotaData(slotProps.data.debitoCreditoNotas, '4 18 22') }}</sup>
              <strong style="color: green; text-align: right;">
                {{ formatCurrency(getSumNota(slotProps.data.debitoCreditoNotas, '4 18 22')) }}
              </strong>
            </div>
          </template>          
        </Column>

        <Column style="width:8%;text-align: right;" sortable>
          <template #header>
            <div style="text-align: right!important; padding-left: 65%!important;">Total</div>
          </template>            
          <template #body="slotProps">
            <strong style="text-decoration: underline;text-decoration-style: double;color:blue;">
              {{ formatCurrency(slotProps.data.total+getSumNota(slotProps.data.debitoCreditoNotas, '4 18 22')+getSumNota(slotProps.data.debitoCreditoNotas, '5 19 23')) }}
            </strong>
          </template>
        </Column>

        <Column :exportable="false" style="width:8%;white-space: nowrap;text-align:center;">
          <template #header>
            <div style="text-align: right!important; padding-left: 25%!important;">Acciones</div>
          </template>           
          <template #body="slotProps">
            <Button icon="pi pi-plus" label="  ND/NC " class="p-button-rounded p-button-success"
              @click="addNotaCD(slotProps.data)" title="Agregar ND/NC" style="min-width: 95%;margin-left: -10%;"/>         
          </template>
        </Column>

        <!-- Expansion de Folio para ver las ND -NC asociadas -->
        <template #expansion="slotProps">
          <DataTable :value="slotProps.data.debitoCreditoNotas" :showHeader="false" header="" :pt="{header: { style: 'display: none' },thead: { style: 'display: none' }}"
            tableStyle="padding-left:0px !important;padding-right:0px !important">                    

            <Column field="motivo" style="width: 29%;text-align: left;">>
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.motivo }}
                </span>
              </template>
            </Column>

            <Column field="tipo_documento_id" style="width: 4%;text-align: left;">
              <template #body="slotProps">
                <Tag :value="getTipoDocumento(slotProps.data.tipo_documento_id)" :severity="slotProps.data.tipo_documento_id === 4 ? 'success' : 'danger'" />
              </template>
            </Column>

            <Column field="folio" style="width: 5%;text-align: right;">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.folio }}
                </span>
              </template>
            </Column>

            <Column field="fecha" style="width: 7%;text-align: center;">
              <template #body="slotProps">
                <span>
                  {{ formatFecha(slotProps.data.fecha) }}
                </span>
              </template>
            </Column>

            <Column field="neto" style="width: 9.5%;text-align: right;">
              <template #body="slotProps">
                <span>
                  {{ formatCurrency(slotProps.data.neto) }}
                </span>
              </template>
            </Column>            

            <Column field="iva" style="width: 7%;text-align: right;">
              <template #body="slotProps">
                <span>
                  {{ formatCurrency(slotProps.data.iva) }}
                </span>
              </template>
            </Column>

            <Column style="width: 8.1%;text-align: right;">
            </Column>            

            <Column field="total" style="width: 7.7%;text-align: right;">
              <template #body="slotProps">
                <span :style="slotProps.data.tipo_documento_id === 4 ? 'color:green;' : 'color:red;'">
                  {{ slotProps.data.tipo_documento_id === 4 ? '' : formatCurrency(slotProps.data.total) }}
                </span>
              </template>
            </Column>            

            <Column field="total" style="width: 7.7%;text-align: right;">
              <template #body="slotProps">
                <span :style="slotProps.data.tipo_documento_id === 4 ? 'color:green;' : 'color:red;'">
                  {{ slotProps.data.tipo_documento_id === 4 ? formatCurrency(slotProps.data.total) : '' }}
                </span>
              </template>
            </Column>

            <Column :exportable="false" style="width: 30%;text-align: right;white-space: nowrap;">
              <template #body="slotProps">
                <Button icon="pi pi-file-pdf" class="p-button-rounded p-button-info me-2"
                  @click="getPDFSII(slotProps.data)" title="Descarga Folio" /> 
                <Button icon="pi pi-eye" class="p-button-rounded p-button-warning me-2"
                  @click="setNotaCD(slotProps.data)" title="Ver ND / NC" />
                <Button icon="pi pi-plus" title=" ND/NC" class="p-button-rounded p-button-success"
                  @click="addNdNc(slotProps.data)" />
              </template>
            </Column>
          </DataTable>          
        </template>
      </DataTable>
    </div>

    <!-- Formulario Notas en modal -->
    <Dialog v-model:visible="notaDialog" :style="{ width: '50%' }" header="Datos del Documento" :modal="true"
      class="p-fluid" :maximizable="true" :closable="false">
      <div align="left" type="solid">
        <b class="text-muted">Antecedentes Documento</b>
      </div>
      <form class="p-fluid">
        <div class="row">
          <div class="col-md-3 field">
            <label for="tipoDocumento" class="mt-4">Tipo Documento</label>
            <AutoComplete id="tipoDocumento" v-model="v$.tipoDocumento.$model" 
              :class="{ 'p-invalid': v$.tipoDocumento.$invalid && submitted }" :suggestions="filteredTipoDocumentos"
              @complete="searchTipoDocumento($event)" field="_nombre" :dropdown="true" forceSelection 
              aria-describedby="tipoDocumento-error" autofocus autocomplete="off" @change="setMotivos($event, index)"/>
            <span v-if="v$.tipoDocumento.$error && submitted">
              <span id="tipoDocumento-error" v-for="(error, index) of v$.tipoDocumento.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="((v$.tipoDocumento.$invalid && submitted) || v$.tipoDocumento.$pending.$response)"
              class="p-error">
              {{ v$.tipoDocumento.required.$message.replace('Value', 'Tipo Documento') }}</small>
          </div>

          <div class="col-md-3 field">
            <label for="motivo" class="mt-4">Motivo</label>
            <Dropdown v-model="v$.motivo.$model" :options="motivos" optionLabel="name" placeholder="" class="w-full md:w-14rem" @change="setDetalles($event)"/>
            <span v-if="v$.motivo.$error && submitted">
              <span id="motivo-error" v-for="(error, index) of v$.motivo.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.motivo.$invalid && submitted) || v$.motivo.$pending.$response" class="p-error">
              {{ v$.motivo.required.$message.replace('Value', 'Valor') }}</small>
          </div>

          <div class="col-md-3 field">
            <label for="folio" class="mt-4">Nro.Folio</label>
            <InputNumber id="folio" v-model="v$.folio.$model" :class="{ 'p-invalid': v$.folio.$invalid && submitted }"
              aria-describedby="folio-error" autofocus autocomplete="off" />
            <span v-if="v$.folio.$error && submitted">
              <span id="folio-error" v-for="(error, index) of v$.folio.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.folio.$invalid && submitted) || v$.folio.$pending.$response" class="p-error">
              {{ v$.folio.required.$message.replace('Value', 'Valor') }}</small>
          </div>

          <div class="col-md-3 field">
            <label for="fecha" class="mt-4">Fecha</label>
            <Calendar id="fecha" v-model="v$.fecha.$model" 
              :class="{ 'p-invalid': v$.fecha.$invalid && submitted }" aria-describedby="fecha-error"
              autocomplete="off" :showIcon="true" dateFormat="dd/mm/yy"/>
            <span v-if="v$.fecha.$error && submitted">
              <span id="fecha-error" v-for="(error, index) of v$.fecha.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.fecha.$invalid && submitted) || v$.fecha.$pending.$response"
              class="p-error">
              {{ v$.fecha.required.$message.replace('Value', 'Fecha') }}</small>
          </div>                 
        </div>        

        <div class="row">
          <div class="col-md-12 field">
            <label for="cliente" class="mt-3">Cliente</label>
            <AutoComplete id="cliente" v-model="v$.cliente.$model"
              :class="{ 'p-invalid': v$.cliente.$invalid && submitted }" :suggestions="filteredClientes"
              @complete="searchCliente($event)" field="_razon_social" :dropdown="true" forceSelection
              aria-describedby="cliente-error" autofocus autocomplete="off" disabled />
            <span v-if="v$.cliente.$error && submitted">
              <span id="cliente-error" v-for="(error, index) of v$.cliente.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="((v$.cliente.$invalid && submitted) || v$.cliente.$pending.$response)"
              class="p-error">
              {{ v$.cliente.required.$message.replace('Value', 'Cliente') }}</small>
          </div> 
        </div>

        <div align="left" type="solid" class="mt-4">
          <b class="text-muted">Documento Referencia</b>
        </div>

        <div class="row mb-4">
          <div class="col-md-2 field">
            <label for="factura_folio" class="mt-3">Folio</label>
            <InputNumber id="factura_id" v-model.trim="form.factura_id" readonly :hidden="true"/>
            <InputNumber id="factura_folio" v-model.trim="form.factura_folio" readonly/>
          </div>          
          <div class="col-md-2 field">
            <label for="factura_fecha" class="mt-3">Fecha Emision</label>
            <Calendar id="factura_fecha" v-model.trim="form.factura_fecha" autocomplete="off" :showIcon="false" dateFormat="dd/mm/yy" readonly/>
          </div>
          <div class="col-md-3 field">
            <label for="factura_neto" class="mt-3">Monto Neto</label>
            <InputNumber id="factura_neto" v-model.trim="form.factura_neto" readonly/>
          </div>                   
          <div class="col-md-2 field">
            <label for="factura_iva" class="mt-3">Monto IVA</label>
            <InputNumber id="factura_iva" v-model.trim="form.factura_iva" readonly/>
          </div>                   
          <div class="col-md-3 field">
            <label for="factura_total" class="mt-3">Monto Total</label>
            <InputNumber id="factura_total" v-model.trim="form.factura_total" readonly/>
          </div>                   
        </div>

        <div class="card p-fluid table_modal mt-2 col-md-12 field" v-if="selectedMotivo">

          <InlineMessage v-for="msg of messages" :key="msg.id" severity="info" class="mb-2" style="width: 100%;">
            {{ msg.content }}
          </InlineMessage>

          <DataTable :value="lineas" showGridlines stripedRows scrollable scrollHeight="400px" 
            @row-select="onRowSelect" @row-unselect="onRowSelect" @row-select-all="onRowSelectAll" @row-unselect-all="onRowSelectAll"
            tableClass="editable-cells-table" tableStyle="min-width: 50rem" editMode="cell" v-model:selection="selectedLineas" 
            dataKey="idx" @cell-edit-complete="onCellEditComplete"
            v-if="lineas.length > 0 && form.model !== 'notadc'">
            <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
            <Column v-for="col of columns" :key="col.idx" :field="col.field" :header="col.header" :hidden="col.hidden">
              <template #editor="{ data, field }">
                <template v-if="col.edit && (form.motivo.code === 'NCM' || form.motivo.code === 'NDM')">
                  <InputText v-model="data[field]" autofocus/>
                </template>
                <template v-else>
                  <span>{{ data[field] }}</span>
                </template>
              </template>
            </Column>                
          </DataTable>
        </div>

        <div align="left" type="solid" class="mt-4">
          <b class="text-muted">Valores Documento</b>
        </div>   

        <div class="row">       
          <div class="col-md-2 field">
            <label for="neto" class="mt-3">Neto</label>
            <InputNumber id="neto" v-model="v$.neto.$model" :class="{ 'p-invalid': v$.neto.$invalid && submitted }"
              aria-describedby="neto-error" autofocus autocomplete="off" readonly/>
            <span v-if="v$.neto.$error && submitted">
              <span id="neto-error" v-for="(error, index) of v$.neto.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.neto.$invalid && submitted) || v$.neto.$pending.$response" class="p-error">
              {{ v$.neto.required.$message.replace('Value', 'Neto') }}</small>
          </div>

          <div class="col-md-1 field">
            <label for="porciva" class="mt-3">%IVA</label>
            <InputNumber id="porciva" v-model="porciva" readonly style="background-color : #d1d1d1;"/>
          </div>   

          <div class="col-md-3 field">
            <label for="iva" class="mt-3">IVA</label>
            <InputNumber id="iva" v-model="v$.iva.$model" :class="{ 'p-invalid': v$.iva.$invalid && submitted }"
              aria-describedby="iva-error" autofocus autocomplete="off" readonly />
            <span v-if="v$.iva.$error && submitted">
              <span id="iva-error" v-for="(error, index) of v$.iva.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.iva.$invalid && submitted) || v$.iva.$pending.$response" class="p-error">
              {{ v$.iva.required.$message.replace('Value', 'IVA') }}</small>
          </div>    

          <div class="col-md-4 field">
            <label for="total" class="mt-3">Total</label>
            <InputNumber id="total" v-model="v$.total.$model" :class="{ 'p-invalid': v$.total.$invalid && submitted }"
              aria-describedby="total-error" autofocus autocomplete="off" readonly />
            <span v-if="v$.total.$error && submitted">
              <span id="total-error" v-for="(error, index) of v$.total.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.total.$invalid && submitted) || v$.total.$pending.$response" class="p-error">
              {{ v$.total.required.$message.replace('Value', 'Total') }}</small>
          </div>                   
        </div>

        <div class="row">
          <div class="col-md-12 field">
            <label for="observacion" class="mt-3">Observaciones</label>
            <Textarea autoResize id="observacion" v-model.trim="v$.observacion.$model" rows="5" 
            :class="{ 'p-invalid': v$.observacion.$invalid && submitted }" aria-describedby="neto-error" />
            <span v-if="v$.observacion.$error && submitted">
              <span id="observacion-error" v-for="(error, index) of v$.observacion.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.observacion.$invalid && submitted) || v$.observacion.$pending.$response" class="p-error">
              {{ v$.observacion.required.$message.replace('Value', 'Observacion') }}</small>            
          </div>          
        </div>                   
      </form>

      <template #footer>
        <div class="row">
          <div class="col-md-7 fw-lighter text-muted" style="text-align: left;">
            <small v-if="form.created_id" ><i class="pi pi-user-plus" style="font-size: 1rem"></i>: {{form.created_id.name}} el {{form.created_at}}</small><br/>
            <small v-if="form.updated_id"><i class="pi pi-user-edit" style="font-size: 1rem"></i>: {{form.updated_id.name}} el {{form.updated_at}}</small>    
          </div>  
          <div :class="form.created_id ? 'col-md-5 field' : 'col-md-12 field'" v-if="!saving">
            <Button label="Cancelar" icon="pi pi-times" class="p-button-text text-danger" @click="hideDialog" />
            <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="saveNota" v-if="!(form.id > 0)"/>
          </div>
          <div :class="form.created_id ? 'col-md-5 field' : 'col-md-12 field'" v-else>
            <ProgressBar mode="indeterminate"/>
          </div>
        </div>
      </template>
    </Dialog>

    <!-- Confirmar elimina un nota -->
    <Dialog v-model:visible="deleteNotaDialog" :style="{ width: '470px' }" header="Confirmar" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-3 text-warning" style="font-size: 2rem; vertical-align: middle;" />
        <span v-if="nota"> ¿Está seguro de borrar el nota?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteNotaDialog = false" />
        <Button label="Si" icon="pi pi-check" class="p-button-text text-danger" @click="deleteNota" />
      </template>
    </Dialog>
  </div> 
</template>

<script>
import useDocsEmitidos from '../../composables/procesos/docsEmitidos'
import { reactive, onMounted, toRaw, isProxy, watch, computed } from 'vue'
import moment from 'moment'
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'

export default {
  setup() {
    const {
      nota,
      notas,
      deleteNotaDialog,
      notaDialog,
      clientes,
      tipoDocumentos,
      factura,
      facturas,
      porciva,
      dt,
      loading,
      saving,
      submitted,
      filters,
      filteredTipoDocumentos,
      filteredClientes,
      filteredFacturas,
      getCRUD,
      storeNota,
      deleteNota,
      selectedMotivo,
      motivos,
      columns,
      lineas,
      selectedLineas,
      getPDFSII,
      expandedRows,
      rango,
      messages
    } = useDocsEmitidos()
    
    moment.locale('es')
    const form = reactive({
      id: null,
      tipoDocumento: null,
      cliente: '',
      factura_id: null,
      factura_folio: null,
      factura_fecha: null,
      factura_neto: null,
      factura_iva: null,
      factura_total: null,
      folio: 0, //null,
      fecha: null,
      porciva: null,
      neto: null,
      iva: null,
      total: null,
      motivo: null,
      detalles: [],
      lineas: [],
      observacion: '',
      model: null,
      despacho_id: null,
      notadc_id: null
    })
    
    const rules = {
      tipoDocumento: { required: helpers.withMessage('El campo es requerido o no corresponde a la despacho', required), },
      cliente: { required: helpers.withMessage('El campo es requerido!', required), },
      observacion: { required: helpers.withMessage('El campo es requerido!', required), },
      folio: { required: helpers.withMessage('El campo es requerido', required), },
      fecha: { required: helpers.withMessage('El campo es requerido', required), },
      neto: { required: helpers.withMessage('El campo es requerido', required), },
      iva: { required: helpers.withMessage('El campo es requerido', required), },
      total: { required: helpers.withMessage('El campo es requerido', required), },
      motivo: { required: helpers.withMessage('El campo es requerido', required), },
    }

    const exportCSV = () => {
      dt.value.exportCSV()
    }

    const confirmDeleteNota = (not) => {
      nota.value = not
      deleteNotaDialog.value = true
    }

    const hideDialog = () => {
      selectedMotivo.value = false
      selectedLineas.value = []      
      notaDialog.value = false
      submitted.value = false
      saving.value = false

      form.id = null
      form.tipoDocumento = null
      form.cliente = ''
      form.factura_id = null
      form.factura_folio = null
      form.factura_fecha = null
      form.factura_neto = null
      form.factura_iva = null
      form.factura_total = null
      form.folio = 0,
      form.fecha = null
      form.porciva = null
      form.neto = null
      form.iva = null
      form.total = null
      form.motivo = null
      form.detalles = []
      form.lineas = []
      form.observacion = ''
      form.model = null
      form.despacho_id = null
      form.notadc_id = null
    }

    const setNotaCD = (data) => {
      selectedMotivo.value = false      
      factura.value = toRaw(facturas.value.filter(function (itm) { return [data.factura_id].indexOf(itm.id) > -1 }))[0]
      notaDialog.value = true
      submitted.value = false
      saving.value = false
      selectedLineas.value = []
      lineas.value = []
      form.lineas = []

      let _motivo = data.motivo.split(": ")
      motivos.value = [{
        code: _motivo[0].trim(),
        name: _motivo[1].trim()
      }]

      let _factura = data.factura_id ? toRaw(facturas.value.filter(function (itm) { return [data.factura_id].indexOf(itm.id) > -1 }))[0] : (data.despacho_id ? toRaw(facturas.value.filter(function (itm) { return [data.despacho_id].indexOf(itm.id) > -1 }))[0] : toRaw(facturas.value.filter(function (itm) { return [data.notadc_id].indexOf(itm.id) > -1 }))[0])
      
      form.model = 'verndc'
      form.factura_id = '4,5'.includes(data.tipo_documento_id) ? data.notadc_id : _factura.id
      form.factura_folio = '4,5'.includes(data.tipo_documento_id) ? data.folio : _factura.folio
      form.factura_fecha = '4,5'.includes(data.tipo_documento_id) ? data.fecha : _factura.fecha
      form.factura_neto = '4,5'.includes(data.tipo_documento_id) ? data.neto : _factura.neto
      form.factura_iva = '4,5'.includes(data.tipo_documento_id) ? data.iva : _factura.iva
      form.factura_total = '4,5'.includes(data.tipo_documento_id) ? data.total : _factura.total      
      
      // let detalles = isProxy(_factura.productos) ? toRaw(_factura.productos) : []
      let detalles = data.lineasDC

      lineas.value = detalles.reduce((acc, ln, index) => {
        acc.push({
          'idx': index + 1,
          'producto_obj' : {'id': ln.producto.id, 'nombre': ln.producto.nombre},
          'producto' : ln.producto.nombre,
          'espesor' : ln.espesor,
          'ancho' : ln.ancho,
          'largo' : ln.largo,
          'cant_despacho' : ln.cant,
          'mc_despacho' : ln.mc,
          'pulg_despacho' : ln.pulg,
          'precio' : ln.precio,
          'tipo_cambio' : ln.tipo_cambio,
          'total' : ln.total,
          'total_mask' : ln.total
        })
        return acc;
      }, [])

      form.id = data.id
      form.tipoDocumento = toRaw(tipoDocumentos.value.filter(function (itm) { return [data.tipo_documento_id].indexOf(itm.id) > -1 }))[0]
      form.cliente = toRaw(clientes.value.filter(function (itm) { return [data.cliente_id].indexOf(itm.id) > -1 }))[0]      
      
      form.folio = data.folio ?? 0,
      form.fecha = data.fecha ? moment(data.fecha).toDate() : moment().toDate()
      form.porciva = data.poriva ?? porciva.value
      form.neto = data.neto
      form.iva = data.iva
      form.total = data.total
      form.observacion = data.observacion
      form.motivo = motivos.value.find(itm => itm.code === _motivo[0]);
      
      form.created_at = data.created_at
      form.created_id = data.created_id
      form.updated_at = data.updated_at
      form.updated_id = data.updated_id

      selectedMotivo.value = true
    }

    const addNdNc = (data) => {
      console.info(data)
      selectedMotivo.value = false      
      nota.value = {}
      form.value = {}
      motivos.value = []
      messages.value = []
      notaDialog.value = true
      submitted.value = false
      saving.value = false
      selectedLineas.value = []
      lineas.value = []

      form.lineas = []
      form.folio = 0,
      form.fecha = moment().toDate()

      //datos del documento(notadc) sobre el que se crea la nota - solo lectura
      form.factura_id = data.factura_id
      form.factura_folio = data.folio
      form.factura_fecha = data.fecha
      form.factura_neto = data.neto
      form.factura_iva = data.iva
      form.factura_total = data.total    
      form.notadc_id = data.id  
      
      // let detalles = isProxy(_factura.productos) ? toRaw(_factura.productos) : []
      let detalles = data.lineasDC

      lineas.value = detalles.reduce((acc, ln, index) => {
        acc.push({
          'idx': index + 1,
          'producto_obj' : {'id': ln.producto.id, 'nombre': ln.producto.nombre},
          'producto' : ln.producto.nombre,
          'espesor' : ln.espesor,
          'ancho' : ln.ancho,
          'largo' : ln.largo,
          'cant_despacho' : ln.cant,
          'mc_despacho' : ln.mc,
          'pulg_despacho' : ln.pulg,
          'precio' : ln.precio,
          'tipo_cambio' : ln.tipo_cambio,
          'total' : ln.total,
          'total_mask' : ln.total
        })
        return acc;
      }, [])

      form.cliente = toRaw(clientes.value.filter(function (itm) { return [data.cliente_id].indexOf(itm.id) > -1 }))[0]      
      form.porciva = data.poriva ?? porciva.value
      form.neto = data.neto
      form.iva = data.iva
      form.total = data.total
      
      form.created_at = data.created_at
      form.created_id = data.created_id
      form.updated_at = data.updated_at
      form.updated_id = data.updated_id
    }
    
    // Agregar NOTA DC a Factura
    const addNotaCD = (data) => {  
      messages.value = []
      motivos.value = []
      factura.value = { ...data }
      nota.value = {}

      notaDialog.value = true
      submitted.value = false
      saving.value = false
      selectedLineas.value = []
      lineas.value = []
      form.lineas = []

      let detalles = isProxy(factura.value.productos) ? toRaw(factura.value.productos) : []

      lineas.value = detalles.reduce((acc, ln, index) => {
        acc.push({
          'idx': index + 1,
          'producto_obj' : {'id': ln.id, 'nombre': ln.nombre},
          'producto' : ln.nombre,
          'espesor' : ln.pivot.espesor,
          'ancho' : ln.pivot.ancho,
          'largo' : ln.pivot.largo,
          'cant_despacho' : ln.pivot.cant_despacho,
          'mc_despacho' : ln.pivot.mc_despacho,
          'pulg_despacho' : ln.pivot.pulg_despacho,
          'precio' : ln.pivot.precio,
          'tipo_cambio' : ln.pivot.tipo_cambio,
          'total' : ln.pivot.total,
          'total_mask' : ln.pivot.total
        })
        return acc;
      }, [])
      
      form.tipoDocumento = null   
      form.detalles = lineas.value
      form.id = nota.value.id ?? null
      form.cliente = factura.value.cliente
      
      form.factura_folio = factura.value.folio
      form.factura_fecha = factura.value.fecha
      form.factura_neto = factura.value.neto
      form.factura_iva = factura.value.iva
      form.factura_total = factura.value.total

      form.factura_id = factura.value.model === 'factura' ? factura.value.id : null
      form.despacho_id = factura.value.model === 'despacho' ? factura.value.id : null
      form.notadc_id = null
      
      form.folio = nota.value.folio ?? 0,
      form.fecha = moment().toDate()
      form.porciva = porciva.value
      form.model = factura.value.model
      
      //limpia los campos
      form.neto = null
      form.iva = null
      form.total = null
      form.observacion =null
      form.motivo = null      
      //si tiene una sola linea de detalle se selecciona 
      if(lineas.value.length === 1) selectedLineas.value = [lineas.value];
    }

    const saveNota = () => {
      onCellUpdateComplete()
      if(form.model === "notadc" && selectedLineas.value.length === 0)
        selectedLineas.value.push({
          'producto_obj' : {'id': form.motivo.code, 'nombre': form.motivo.name + ' a folio #' + form.factura_folio },
          'total' : form.total
        })   

      messages.value = []
      submitted.value = true
      
      if(!v$._value.$invalid){
        if (selectedLineas.value.length > 0 && selectedLineas.value.length < 61) {
          form.lineas = selectedLineas.value
          storeNota(form)
        }else
          messages.value = [{content: 'Por normativa del SII debe seleccionar entre 1 y 60 lineas de detalles', id: lineas.value.length}]         
      } 
    }

    const searchTipoDocumento = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredTipoDocumentos.value = [...tipoDocumentos.value]
        }
        else {
          filteredTipoDocumentos.value = tipoDocumentos.value.filter((tdocumento) => {
            return tdocumento._nombre.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchCliente = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredClientes.value = [...clientes.value]
        }
        else {
          filteredClientes.value = clientes.value.filter((cliente) => {
            return cliente._razon_social.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const formatFecha = (value) => {
      return moment(value).format("DD-MM-YYYY")
    }

    const formatCurrency = (value) => {
      return new Intl.NumberFormat('es-CL').format(value)
    }

    const sumDetalles = computed(() => {
      return selectedLineas.value.reduce(
        (acumulador, linea) => {
          return {
            suma_cant_despacho: acumulador.suma_cant_despacho + Number(linea.cant_despacho),
            suma_total: acumulador.suma_total + linea.total,
            suma_total_mask: acumulador.suma_total_mask + linea.total_mask,
          };
        },
        { suma_cant_despacho: 1, suma_total: 0, suma_total_mask: 0 } // Valores iniciales
      );
    });

    const onCellUpdateComplete = () => {
      let sumatoria = sumDetalles
      if(form.motivo.code !== 'NCT' && form.motivo.code !== 'NDT'){
        form.neto = sumatoria.value.suma_total
        form.iva  = Number(Math.round(form.neto * form.porciva / 100))
        form.total = Number(Math.round(form.neto + form.iva))
      }else{
        form.neto = 0
        form.iva  = 0
        form.total = 0   
      }
    }

    const getTipoDocumento = (tdoc) => {
      return toRaw(tipoDocumentos.value.filter(function (itm) { return [tdoc].indexOf(itm.id) > -1 }))[0].codigo              
    }

    const getSumNota = (notas,tdocs) => {
      return notas.reduce(function(acc, nt) {return tdocs.match(nt.tipo_documento_id) ? acc + nt.total : acc + 0 }, 0)
    }

    const getNotaData = (notas, tdocs) => {
      let countNotas = 0;

      const tdocsArray = tdocs.split(' ').map(Number); // Convertir a array de enteros

      notas.forEach(nota => {
        if (tdocsArray.includes(nota.tipo_documento_id)) {
          if (nota.motivo?.trim().startsWith("NDT:") || nota.motivo?.trim().startsWith("NCT:")) {
            countNotas++;
          }
        }
      });
      return countNotas === 0 ? '' : '(' +countNotas+')'
    };

    const setDetalles = (e) => { 
      selectedLineas.value = []
      form.neto = null
      form.iva = null
      form.total = null 

      if(e.value.code === 'NCA' || e.value.code === 'NDA'){
        selectedLineas.value = [...lineas.value]
        form.neto = form.factura_neto
        form.iva = form.factura_iva
        form.total = form.factura_total
      }else{
        //si tiene una sola linea de detalle se selecciona 
        if(lineas.value.length === 1) selectedLineas.value = [...lineas.value];
      }
      selectedMotivo.value = true
    }

    const setMotivos = (e) => {
      selectedMotivo.value = false
      selectedLineas.value = []
      form.neto = null
      form.iva = null
      form.total = null 

      if(e.value.codigo === 'NDE')
        motivos.value = [
        { name: 'Nota de Débito de Anulación', code: 'NDA' },
          { name: 'Nota de Débito para Corregir Montos', code: 'NDM' },
          { name: 'Nota de Débito para Corregir Texto', code: 'NDT' },
        ]
      else
        motivos.value = [
          { name: 'Nota de Crédito de Anulación', code: 'NCA' },
          { name: 'Nota de Crédito para Corregir Montos', code: 'NCM' },
          { name: 'Nota de Crédito para Corregir Texto', code: 'NCT' },          
        ]      
    }

    const onRowSelect = (event) => {
      onCellUpdateComplete()
    };

    const onRowSelectAll = (event) => {
      selectedLineas.value = event.data !== undefined ? event.data : []
      onCellUpdateComplete()
    };

    const onCellEditComplete = (event) => {
      let { newData, index } = event
      newData.total = newData.cant_despacho * newData.precio
      newData.total_mask = newData.total
      lineas.value[index] = newData
      //
      selectedLineas.value = selectedLineas.value.map(item => {
        if (item.idx === newData.idx) {
          return {
            ...item,
            cant_despacho: newData.cant_despacho,
            precio: newData.precio,
            total: newData.cant_despacho * newData.precio,
            total_mask: newData.total
          };
        }
        return item;
      });
      onCellUpdateComplete()
    }

    const v$ = useVuelidate(rules, form)

    watch(selectedLineas, (newSelection) => {
      if (lineas.value.length === 1 && newSelection.length === 0) {
        selectedLineas.value = [...lineas.value]
      }
    }) 

    onMounted(getCRUD)

    return {
      dt, 
      loading,
      saving,
      nota,
      notas,
      factura,
      facturas,
      porciva,
      filters,
      deleteNotaDialog,
      notaDialog,
      submitted,
      v$,
      form,
      filteredTipoDocumentos,
      filteredClientes,
      filteredFacturas,
      searchTipoDocumento,
      searchCliente,
      hideDialog,
      confirmDeleteNota,
      deleteNota,
      exportCSV,
      setNotaCD,
      saveNota,
      storeNota,
      formatCurrency,
      onCellUpdateComplete,
      selectedMotivo,
      motivos,
      lineas,
      columns,
      getPDFSII,
      selectedLineas,
      expandedRows,
      formatFecha,
      getTipoDocumento,
      addNotaCD,
      getSumNota,
      getNotaData,
      addNdNc,
      rango,
      getCRUD,
      setDetalles,
      setMotivos,
      messages,
      onRowSelect,
      onRowSelectAll,
      onCellEditComplete,
      sumDetalles
    }
  },
}
</script>

<style scoped>
  .ndc-table .centered-header .p-column-title {
    text-align: right !important;
    width: 100% !important;
  }

  .ndc-table .centered-header .p-column-filter {
    margin: 0 auto !important; /* Centra el input de filtro */
  }
</style> 